export default __webpack_public_path__ + "static/media/Emoji_Bar_Love.3bf621c5.svg";